import { render, staticRenderFns } from "./ChatFloatingOverlays.vue?vue&type=template&id=0ce89611"
import script from "./ChatFloatingOverlays.vue?vue&type=script&lang=js"
export * from "./ChatFloatingOverlays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports